import React from 'react';
import { Shield } from 'lucide-react';
import clsx from 'clsx';
import { useTheme } from '../../contexts/ThemeContext';

export const UserGuideOverview: React.FC = () => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';

    return (
        <section id="overview">
            <div id="overview-intro" className={clsx('p-8 rounded-2xl border', isDark ? 'bg-gradient-to-br from-blue-900/30 to-indigo-900/30 border-blue-800' : 'bg-gradient-to-br from-blue-50 to-indigo-50 border-blue-200')}>
                <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-500 flex items-center justify-center">
                        <Shield className="text-white" size={32} />
                    </div>
                    <div>
                        <h1 className={clsx('text-3xl font-bold', isDark ? 'text-white' : 'text-slate-800')}>
                            Magnus Resolve Guide
                        </h1>
                        <p className="text-lg text-slate-500">Comprehensive Failure Analysis & Reliability Platform</p>
                    </div>
                </div>
                <p className={clsx('text-lg leading-relaxed', isDark ? 'text-slate-300' : 'text-slate-600')}>
                    Resolve is your command center for tracking, analyzing, and eliminating product failures.
                    It integrates <strong>FRACAS</strong>, <strong>8D Problem Solving</strong>, and <strong>Reliability Analytics</strong>
                    into a single source of truth, powered by AI Intelligence.
                </p>
            </div>
        </section>
    );
};
